import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import DotNetSvgColor from '../assets/dotnet.svg';

export const DotNetColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-dotnet" className={cx('sdkIcon', className)} size={size} {...props}>
    <DotNetSvgColor />
  </LegacyIcon>
);
